/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateNextBestActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'
import {UpdateNextBestActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'


export const updateNextBestAction = (request: UpdateNextBestActionRequest, options?: CashRequestOptions) => post<UpdateNextBestActionRequest, UpdateNextBestActionResponse>("/cash-app/goose-cash/v3/update-next-best-action", request, {...options, rejectOnError: true })